import React from "react";

const NoShots = () => {
    return <h2 className="txt-center">There are no images for this view yet.</h2>;
};

export default NoShots;
